document.addEventListener("DOMContentLoaded",()=>{
  const gate=document.getElementById("oneoff-member-gate");
  if(!gate) return;

  document.documentElement.classList.add("oogate-lock");

  document.addEventListener("keydown",(e)=>{
    if(e.key==="Escape"){
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  },true);

  window.addEventListener("wheel",(e)=>{
    e.preventDefault();
  },{passive:false,capture:true});

  window.addEventListener("touchmove",(e)=>{
    e.preventDefault();
  },{passive:false,capture:true});

  gate.querySelector(".oogate__backdrop").addEventListener("click",(e)=>{
    e.preventDefault();
    e.stopPropagation();
  });
});